// Author: Luis Booth - February 2019
// PR Freeze!
/*     🧢
**     👦
** ❄️👈🏽👕
*/

import React, { Component } from 'react';
// import { DropDownDate } from 'react-nice-inputs';
import { VacationContext } from 'js/components/step1/VacationContext';
import moment from 'moment';
import StupidDatePicker from 'js/components/global/StupidDatePicker';

const revistaEstilo = {
  backgroundColor: '#f2f2f2',
  padding: '1.5rem',
  marginBottom: '0.5rem',
  marginTop: '0.5rem',
  width: '100%',
};

class Infant extends Component {

  state = {
    checkedSeatType: 'lap',
  };

  // _updateSeatType = (value, name, context) => {
  //   const guestInfo = { ...context.state.guestInfo };

  //   guestInfo[name] = value;

  //   context.setInputValue(value, name);

  //   this.setState({ name: value });
  // }

  componentDidMount() {
    if(this.props.seatType) {
      this.setState({ checkedSeatType: this.props.seatType });
    }
  }

  /* eslint-disable */
  componentDidUpdate() {
    if(this.props.seatType !== this.state.checkedSeatType) {
      this.setState({ checkedSeatType: this.props.seatType });
    }
  }
  /* eslint-enable */

  _updateSeatType = (e, context, guestIndex) => {

    const { name, value } = e.target;

    const realName = name.split('-')[1];

    console.log('realName', realName);

    console.log(e.target.name);
    console.log(e.target.value);
    console.log(guestIndex);

    this.setState({ checkedSeatType: value });

    context.setSeatType(value, realName, guestIndex);
  }

  _updateDateOfBirth = (e, context, guestIndex) => {

    if (e.target) {
      const input = e.target.current;
      const { name, value } = input;

      let formattedValue = moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD');

      if (!moment(formattedValue).isValid()) {
        formattedValue = '';
      }

      context.setDateOfBirth(formattedValue, name, guestIndex);
    }
  }

  // _setMinDate = (fields) => {

  //   const minDate = fields.checkOutDate ? moment(fields.checkOutDate).subtract(2, 'years').add(1, 'days').format('YYYY-MM-DD') : moment().subtract(2, 'years').format('YYYY-MM-DD');

  //   return minDate;
  // }

  // _setMaxDate = (fields) => {

  //   const maxDate = fields.checkInDate ? moment(fields.checkInDate).subtract(1, 'days').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');

  //   return maxDate;
  // }

  _setMinDate = () => {

    const minDate = moment().subtract(17, 'years').year();

    return minDate;
  }

  _setMaxDate = () => {

    const maxDate = moment().year();

    return maxDate;
  }

  render() {

    const { infantIndex } = this.props;

    return (
      <VacationContext.Consumer>
        {(context) => {

          // const { seatType } = this.state;

          // console.log(seatType);
          const infantError = context.state.addGuestErrorDetails[`dob_guest_${infantIndex}_infant`];

          let prepopulatedDate = null;
          let prepopulatedSeat = null;

          if(context.state.guestInfo.infants) {
            prepopulatedDate = context.state.guestInfo.infants[`dob_guest_${infantIndex}`];
            prepopulatedSeat = context.state.guestInfo.infants[`seat_guest_${infantIndex}`];
          }

          console.log(prepopulatedSeat);

          return (
            <div style={revistaEstilo}>
              <div className="sm-12 infant-label">
                Infant {infantIndex + 1} birthday <sup>*</sup>
              </div>
              <div className="sm-12">
                { /* <DropDownDate name={`dob_guest_${infantIndex}`}
                  classList={ infantError !== undefined ? ['is-invalid', 'row'] : ['row'] }
                  onChange={(value, name) => this._updateDateOfBirth(value, name, context, infantIndex)}
                  attrs={ { required: true } }
                  labelM=""
                  labelD=""
                  labelY=""
                  mmClassList={ [ 'sm-4' ] }
                  ddClassList={ [ 'sm-4' ] }
                  yyyyClassList={ [ 'sm-4' ] }
                  defaultTextM="MM"
                  defaultTextD="DD"
                  defaultTextY="YYYY"
                  minDate={ this._setMinDate(context.state.fields) }
                  maxDate={ this._setMaxDate(context.state.fields) }
                  format="YYYY-MM-DD"
                  value={prepopulatedDate}
                />
              */ }

                <StupidDatePicker name={`dob_guest_${infantIndex}`}
                  maxYear={ this._setMaxDate() }
                  minYear={ this._setMinDate() }
                  onChange={ (e) => this._updateDateOfBirth(e, context, infantIndex) }
                  attrs={ { required: true } }
                  wrapperClassName={ infantError !== undefined ? 'is-invalid' : '' }
                  defaultValue={prepopulatedDate}
                />

              </div>

              {/*               { context.state.fields.airIncluded &&
                <Fragment>
                  <div className="sm-12 seat-type-radio input-list-wrap">
                    <div className="radio-group">
                      <label htmlFor={`inlap-seat_guest_${ infantIndex }`} className="control-label">
                        <input type="radio" name={`inlap-seat_guest_${ infantIndex }`}
                          className={ this.state.checkedSeatType === 'lap' ? 'checked' : '' }
                          value="lap"
                          checked={this.state.checkedSeatType === 'lap'}
                          onChange={ (e) => this._updateSeatType(e, context, infantIndex) } />
                          In lap
                      </label>
                    </div>

                    <div className="radio-group">
                      <label htmlFor={`inseat-seat_guest_${ infantIndex }`} className="control-label">
                        <input type="radio" name={`inseat-seat_guest_${ infantIndex }`}
                          className={ this.state.checkedSeatType === 'seat' ? 'checked' : '' }
                          value="seat"
                          checked={this.state.checkedSeatType === 'seat'}
                          onChange={ (e) => this._updateSeatType(e, context, infantIndex) } />
                          In Seat
                      </label>
                    </div>
                  </div>
                </Fragment>
              } */}
            </div>
          );
        }}
      </VacationContext.Consumer>
    );
  }
}

export default Infant;



// WEBPACK FOOTER //
// ./js/components/step1/Infant.js